var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#BE5400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8853 17.6387C10.8861 17.2247 11.2222 16.8891 11.6362 16.8897L17.1632 16.8969C17.2184 16.8969 17.2633 16.8522 17.2633 16.797L17.2705 11.271C17.2711 10.8568 17.6073 10.5215 18.0215 10.522C18.4355 10.5228 18.7711 10.8589 18.7705 11.273L18.7633 16.7989C18.7633 16.8542 18.808 16.899 18.8632 16.8991L24.3892 16.9063C24.8032 16.9068 25.1385 17.2433 25.1382 17.6573C25.1376 18.0715 24.8014 18.4068 24.3872 18.4063L18.8612 18.3991C18.806 18.399 18.7612 18.4437 18.7611 18.4989L18.7539 24.0259C18.7534 24.4399 18.4169 24.7752 18.0029 24.7749C17.5887 24.7744 17.2534 24.4381 17.2539 24.0239L17.2611 18.497C17.2612 18.4418 17.2165 18.3969 17.1612 18.3969L11.6343 18.3897C11.2201 18.3891 10.8847 18.0529 10.8853 17.6387Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircle);
export default __webpack_public_path__ + "static/media/icon-plus-circle.e4e6edd28acf757626e2e7bccaffdac1.svg";
export { ForwardRef as ReactComponent };